import { Json } from '@gift/types/Json';
import { PaintTarget } from '@gift/types/plugins/paintTargets';
import { Dictionary } from '@reduxjs/toolkit';
import { variablePlugins } from './_registry';

export const createPaintables = (
    variables: Json.Variable<any>[],
    input: Dictionary<Json.Input<any>>,
    variant: Json.Variant<any>,
    target: PaintTarget
) => {
    return variables.flatMap(v => variablePlugins
        .require(v.pluginId)
        .toFfCanvas(v, input[v.id]!.value, variant.palette, target));
};